export default {
  computed: {
    firstName () {
      return this.$store.getters['user/user'].firstName
    },
    lastName () {
      return this.$store.getters['user/user'].lastName
    },
    company () {
      return this.$store.getters['user/user'].company
    },
    role () {
      return this.$store.getters['user/user'].role
    },
    picture () {
      return this.$store.getters['user/user'].profilePic
    },
    email () {
      return this.$store.getters['user/user'].email
    }
  },
  created () {
    this.field = {}
  },
  methods: {
    onUpdateFields (fields) {
      this.fields = fields
    }
  }
}